import LoginForm from './LoginForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import ForgotPasswordNewForm from './ForgotPasswordNewForm';
import LoginFormNew from './LoginFormNew';

export {
	LoginForm,
	ForgotPasswordForm,
	ForgotPasswordNewForm,
	LoginFormNew
}